// Predicate that decides whether the multiplayer gateway WS should connect
// for the given app-level game mode. Extracted from App.tsx so the call site
// can't regress to the old `gameMode !== 'menu'` shape — that incorrectly
// connected in single-player (audit 2026-07-16, finding B1).
//
// Multiplayer WS only matters when the player is interacting with the
// multiplayer lobby or an active multiplayer match. Single-player should
// never try to reach the gateway; the match runs entirely against the
// local WASM sim with no server authority.
export type GameMode =
  | 'menu'
  | 'setup'
  | 'single'
  | 'multiplayer-lobby'
  | 'multiplayer-match'
  | 'spectate';

export function shouldConnectMpLobby(gameMode: GameMode): boolean {
  return gameMode === 'multiplayer-lobby' || gameMode === 'multiplayer-match';
}
